export { default } from "./createChainedFunction.mjs";